define('app/editor/dialogs/SaveMonitorDialogView',['require','./SaveDialogView','app/app','app/config/strings','glu/util','glu/dialog','hbs!./SaveMonitorDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('./SaveDialogView'),
		App = require('app/app'),
		strings = require('app/config/strings'),
		_ = require('glu/util'),
		dialog = require('glu/dialog');

	var view = SaveDialogView.extend({

		dialogTitle: 'Save Monitor',

		template: require('hbs!./SaveMonitorDialogView.hbs'),

		ui: {
			$selectedDashboard: '.select-box',
			$copyFieldId: '#save-dialog-as-a-copy'
		},

		events: {
			'change @ui.$selectedDashboard': 'checkDashboardSelection',
			'change #save-dialog-name': 'onChangeName',
			'keyup #save-dialog-name': 'onChangeName',
			'change #save-dialog-description': 'onChangeDesc',
			'keyup #save-dialog-description': 'onChangeDesc',
			'change #save-dialog-as-a-copy': 'onChangeAsCopy'
		},

		initialize: function() {
			this.selectSaveAs = this.options.saveAs;
		},

		onRender: function() {
			this.ui.$selectedDashboard.comboBox();
		},

		getName: function() {
			if (this.selectSaveAs) {
				return this.model.getName() + ' (copy)';
			}
			return this.model.getName();
		},

		getDescription: function() {
			return this.model.getDescription();
		},

		getDashboard: function() {
			return this.model.getDashboardId();
		},

		dashboardOptions: function() {
			//find the available dashboards other than fixed that is bound to this domain
			var selected = App.dashboards.filter(function(d) {
				return ((d.get('dashboardType') === 'BASIC' || d.get('dashboardType') === 'CUSTOM') && d.get('owner') === App.user.getUsername());
			});

			var dashboardId = this.getDashboard();
			return selected.map(function(d) {
				return {
					value: d.get('id'),
					label: d.get('name'),
					isSelected: dashboardId === d.get('id')
				};
			});
		},

		checkDashboardSelection: function() {
			if (this.uigetDashboard() !== 'default') {
				this.ui.$selectedDashboard.parent().removeClass('has-error');
			} else {
				this.ui.$selectedDashboard.parent().addClass('has-error');
			}
		},

		isDashboardSelected: function() {
			if (this.uigetDashboard() !== 'default') {
				return true;
			}
			this.ui.$selectedDashboard.parent().addClass('has-error');
			return false;
		},

		uigetDashboard: function() {
			return this.$el.find(this.ui.$selectedDashboard).val();
		},

		uisetDashboard: function(dashboard) {
			return this.$el.find(this.ui.$selectedDashboard).val(dashboard);
		},

		save: function() {
			var self = this;
			if (this.isValid()) {
				this.model.set('saveInProgress', true, {
					silent: true
				});

				if (this.hasSaveAsCopyOption() && this.isCopySelected()) {
					var copy = this.model.clone();
					copy.setName(this.uigetName());
					copy.setDescription(this.uigetDescription());
					copy.setDashboardId(self.uigetDashboard());
					copy.unset('id');
					copy.save().then(function(saved) {
						self.navigateTo('/domains/' + copy.getDomainId() + '/monitors/' + saved.id);
					});
				} else {
					self.model.setName(self.uigetName());
					self.model.setDescription(self.uigetDescription());
					self.model.setDashboardId(self.uigetDashboard());
					self.model.save().then(function() {
						self.model.set('saveInProgress', false, {
							silent: true
						});
						self.model.trigger('saved');
					});
				}
				dialog.close();
			}
		},

		hasSaveAsCopyOption: function() {
			return !this.model.isNew();
		},

		hasSaveAsSelected: function() {
			return this.selectSaveAs;
		},

		isCopySelected: function() {
			return this.$el.find(this.ui.$copyFieldId).is(':checked');
		},

		isOwner: function() {
			return this.model.isOwner();
		},

		onChangeAsCopy: function() {
			this.isValid();
		},

		validate: function(val, field) {
			var self = this;
			// call base class isValid function
			SaveDialogView.prototype.validate.call(this, val, field);

			if (this.$el.find(this.nameFieldId).parent().hasClass('has-error')) {
				return;
			}

			var desiredName = this.uigetName();
			// check for duplicate name
			// get all monitors names
			var monitor = _.find(App.domains.models, function(domain) {
				return _.find(domain.monitorCollection().models, function(m) {
					if (self.isCopySelected()) {
						if (m.isOwner() && m.get('modelName') === strings.monitorModelName && m.getName().trim() === desiredName.trim()) {
							return m;
						}
					} else {
						if (m.isOwner() && m.get('modelName') === strings.monitorModelName &&
							m.getName().trim() === desiredName.trim() &&
							m.getId() !== self.model.getId()) {
							return m;
						}
					}

				});
			});

			if (monitor) {
				this.$el.find(this.nameFieldId).parent().addClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text('Duplicate monitor name');
			} else {
				this.$el.find(this.nameFieldId).parent().removeClass('has-error');
				this.$el.find(this.nameFieldId).parent().find('span.help-block').text();
			}
		},

		serializeData: function() {
			return this;
		}

	});

	return view;
});

